import { render, staticRenderFns } from "./BillPosTakeOut.vue?vue&type=template&id=04ec560e&scoped=true"
import script from "./BillPosTakeOut.vue?vue&type=script&lang=js"
export * from "./BillPosTakeOut.vue?vue&type=script&lang=js"
import style0 from "./BillPosTakeOut.vue?vue&type=style&index=0&id=04ec560e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04ec560e",
  null
  
)

export default component.exports